export enum RolesEnum {
  ADMINISTRATOR = 'ST',
  NETWORK_ADMINISTRATOR = 'NA',
  ACCOUNT_ADMINISTRATORS = 'AA',
  PROGRAM_ADMINISTRATOR = 'PA',
  REPORT_VIEWER = 'RV',
}
